// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fd99f38e","732":"0ca8b8ed","977":"ad54fbfc"}[chunkId] + ".chunk.js";
};